<template>
  <div class="power-container">
    <div class="power-areas">
      <CommonTree />
    </div>
    <div class="power-content">
      <Amap :isSearchShow='true' />
    </div>
    <div class="police-icon" @click="policeClose">
      <img :src="img.light.carat.gis.policePosition" />实时报警({{policeNum}})
    </div>
    <AlarmFloatWin v-model="isShowPoliceBox" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import CommonTree from '../tree/Index'
import Amap from '@/components/map/amap'//地图
import AlarmFloatWin from './policePage'
export default {
  name: 'FactoryAdjustIndex',
  components: {
    CommonTree,
    Amap,
    AlarmFloatWin,

  },
  props: {
    args: {
      type: Object,
      default() {
        return {
          type: 'common',
        }
      }
    },
  },
  data() {
    return {
      isShowPoliceBox: false,
      policeNum: 0
    }
  },
  computed: {
    ...mapGetters('auth', ['funCodes']),
    ...mapState('common', ['productCodes']),
    ...mapState('group', ['selectedDevices', 'selectedNode']),
    ...mapState('cmd', ['cmdResultRefresh', 'cmds', 'commands', 'luxDataRefreshed', 'luxes', 'windowOnResize', 'clearOldLogs']),
    currentStation: function () {
      if (this.selectedNode.type == this.productCodes.station) {
        return this.selectedNode;
      } else if (this.selectedDevices.length > 0) {
        return this.selectedDevices[0];
      }
      return null;
    },
  },
  watch: {
    selectedNode() {
      this.initData();
    },
  },
  mounted: function () {
    this.$store.dispatch('group/getGroupAndStations', -1);
    this.initData();
  },
  methods: {
    initData: function () {
      let ajaxData = {
        "groupId": this.selectedNode.id,
        "paramId": 0,
        "level": 0,
        "type": 0,
        "done": false,
        "start": "2023-03-01 10:24:00",
        "end": "2023-03-14 10:24:00",
        "size": 9999,
        "index": 1
      }
      let now1 = new Date();
      ajaxData.end = now1.format('yyyy-MM-dd HH:mm:ss');
      now1.setDate(now1.getDate() - 30);
      ajaxData.start = now1.format('yyyy-MM-dd HH:mm:ss');
      this.$axios.post(`//${this.domains.trans}/station/light/QueryAlarm`, ajaxData).then(res => {
        if (res.code == 0) {
          this.policeNum = res.data.count;
        }
      });
    },
    policeClose() {
      this.isShowPoliceBox = !this.isShowPoliceBox
      this.$sessionData.sessionData('set', "policeBox", this.isShowPoliceBox);
    },
    cmdGot: function (params) {
      this.$refs.lightList1.dealCmd(params);
    },
  }
}
</script>
<style scoped>
.switch-button-list {
  width: 100%;
  height: 45px;
  display: flex;
  flex-direction: initial;
}
.power-button-item {
  cursor: pointer;
  height: 44px;
  text-align: center;
  display: flex;
  flex-direction: initial;
  align-items: center;
  cursor: pointer;
  text-align: center;
  margin-right: 60px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9eb1c8;
}
.power-button-item.active {
  color: #fff;
  border-bottom: 2px solid #fff;
}
.power-button-item img {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 8px;
}
.area-content {
  height: 100px;
  flex: auto;
  overflow: auto;
}
.area-content::-webkit-scrollbar {
  display: none;
}
.power-container {
  /* border: solid 1px red; */
  width: 100%;
  display: flex;
  background-color: #011220;
}
.power-areas {
  /* border: solid 1px red; */
  width: 300px;
  margin: 3px;
  flex: none;
  background-color: #001f37;
  display: flex;
  flex-direction: column;
}
.power-content {
  margin: 3px;
  width: 0;
  flex: auto;
  display: flex;
  flex-direction: column;
  /* background: #0f2137; */
}
.power-title {
  padding: 0 10px 10px;
  height: 100px;
  flex: none;
  text-align: center;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #51e7f3;
  position: relative;
}
.power-title-center {
  padding-top: 8px;
  /* border: solid 1px red; */
  width: 400px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.power-title-center img {
  position: absolute;
  bottom: 20px;
  left: 0;
  /* left: ; */
}
.bright-env {
  /* border: solid 1px red; */
  position: absolute;
  top: 20px;
  right: 60px;
  /* width: 200px; */
  height: 30px;
  display: flex;
}
.bright-env-item {
  display: flex;
  align-items: center;
}
.bright-env-item img {
  margin: 0 5px;
}
.env-item-title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.env-item-value {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #51e7f3;
}
.light-control-menu {
  height: 50px;
  flex: none;
}
.light-control-list {
  height: calc(100% - 50px);
  flex: auto;
}

.police-icon {
  width: 154px;
  height: 44px;
  background: #e92e5e;
  opacity: 0.8;
  border-radius: 6px;
  position: fixed;
  right: 18px;
  bottom: 35px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  z-index: 500;
  cursor: pointer;
  text-align: center;
  line-height: 44px;
}
.police-icon img {
  vertical-align: middle;
  width: 18px;
  height: 18px;
  margin: 0 10px 0 0;
}
</style>
